<template>
  <div class="globalHeader">
    <div class="head-hall">
      {{ hallInfo && hallInfo.departName ? hallInfo.departName : '' }}
    </div>
    <ul class="head-menu">
      <li v-for="(item, index) in menu" :key="index" @click="goPage(item)">
        {{ item.label }}
      </li>
    </ul>
    <div class="head-action"> 
      <span class="action" @click="systemVisible=!systemVisible">切换系统</span>
      <!-- <el-drawer
        :visible="systemVisible"
        direction="ttb"
        size="50%"
        :close="systemVisible=false"
      > -->
      <div class="system-wrapper" v-show="systemVisible">
        <div style="float:right;font-size:20px"><i class="el-icon-close" @click="close"></i></div>
        <ul class="head-menu wrap">
          <li v-for="(clauses, index) in systemMenu" :key="index"  v-click-outside="close">
            <h3 class="__title">{{ clauses.name }}</h3>
            <div class="menu-list">
              <div class="card" :style="itemListShow(item) ? 'padding:10px': 'padding:0'" v-for="(item, index) in clauses.children" :key="index" @click="goSystemPage(item)">
                <template v-if="itemListShow(item)">
                  <img v-if="item.icon && item.icon.startsWith('http')" :src="item.icon" alt="">
                  <img v-else :src="'https://www.onewindow.cn/img/systemIcon/' + item.icon + '.png'" alt="">
                  {{ item.name }}
                </template>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- </el-drawer> -->
      <el-button type="primary" size="small" @click="toPage">{{ sysTitle }}</el-button>
      <i class="el-icon-message-solid" style="margin:0 10px;font-size:20px"></i>
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          <div class="head-img">
            <img :src="userInfo.avatar" alt="">
          </div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-s-tools" command="0">个人设置</el-dropdown-item>
          <el-dropdown-item icon="el-icon-s-goods" command="1">我的收藏</el-dropdown-item>
          <el-dropdown-item icon="el-icon-error" command="2">我的纠错</el-dropdown-item>
          <el-dropdown-item icon="el-icon-circle-plus" command="3">我的添加</el-dropdown-item>
          <el-dropdown-item icon="el-icon-s-unfold" command="e">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {listByUser, getTicket} from '@/api/login'
import { getFrontConfig, utils } from 'ow-service-component'
import { ACCESS_TOKEN, ACCESS_SECRET } from "@/store/mutation-types"
import Vue from 'vue'
export default {
  name: 'GlobalHeader',
  components: {
  },
  data () {
    return {
      menuList: {
        projectName: '宜城市政务服务中心政务中枢',
        menu: {
          home: {
            label: '主页',
            type: 'homePage',
            // page: [
            //   {
            //     label: '首页',
            //     path: '/home'
            //   },
            //   {
            //     label: 'OA中心'
            //   },
            //   {
            //     label: '培训中心'
            //   },
            //   {
            //     label: '业务中心'
            //   },
            //   {
            //     label: '指挥中心'
            //   }
            // ]
          }
        }
      },   
      visible: false,
      systemMenu: [],
      systemVisible: false,
      sysTitle: '智能导办系统'
    }
  },
  computed: {
    ...mapState(["user"]),
    userInfo () {
      console.log(this.user)
      return this.user.info
    },
    hallInfo () {
      const v = this.user.hallInfo
      // TODO 这里需要根据名字传入，着急
      if (v.id == '1947495986628792320') {
        this.sysTitle = '受理辅助系统'
      } else {
        this.sysTitle = '智能导办系统'
      }
      return v
    },
    menu () {
      return this.menuList.menu.home.page
    },
    isAdmin() {
      return Array.from(this.user.roleCode).some(role => ['admin', 'allHalls_admin'].includes(role))
    }
  },
  created() {
    this.getMenuInfo()
  },
  methods: {
    ...mapActions(['Logout']),
    close() {
      this.systemVisible = false
    },
    getMenuInfo() {
      listByUser().then(res => {
        console.log(res)
        if (res.success) {
          this.systemMenu = res.result
        }
      }).catch(err => {
        console.error(err)
        this.$message.error('获取数据失败')
      })
    },
    itemListShow (item) {
      // 如果配置了 admin 属性 只有管理员才能查看
      return item.isAdmin ? this.isAdmin : true
    },
    goSystem () {
      console.log(getFrontConfig())
      if (getFrontConfig().SSO_URL) {
        window.open(getFrontConfig().SSO_URL, '_blank')
      } else {
        this.$message.warning('查询不到对应的参数')
      }
    },
    goSystemPage(item) {
      console.log(item.url)
      if (item.url) {
        const token = localStorage.getItem('token')
        const secret = localStorage.getItem('secret')
        getTicket(token, secret).then(response => {
          if (response.success) {
            const ticket = response.data
            let params = (eval("(" + item.queryArgs + ")") || {})

            for (let param in params) {
              if (params[param].startsWith('this.')) {
                try {
                  params[param] = eval(params[param]) || ''
                } catch (err) {
                  params[param] = ''
                }
              }
            }

            params['systemTitle'] = item.name || ''
            // jurisdiction 是否需要传参
            if (item.jurisdiction) {
              params['ticket'] = ticket
              let queryStr = utils.axiosUtils.genQuery(params)
              window.open(`${item.url}?${queryStr}`, '_blank')
            } else {
              // item.jurisdiction 为假 不添加参数，否则 ? 转译会导致参数错误
              window.open(`${item.url}`, '_blank')
            }
          }
        }).catch(err => {
          console.log(err);
          if (err.errorCode == '401') {
            this.$message.warning('登录过期，请重新登录')
          } else {
            this.$message.error(err.message)
          }
          this.$router.push('/login')
        })
      }
      this.systemVisible = false
    },
    toPage () {
      window.history.pushState(null, '', '/subApplication/GovernmentGuideWeb')
    },
    handleCommand (command) {
      if (command == 'e') {
        let systemName = 'MAIN_CENTER_URL'
        const redirectUrl = getFrontConfig()['sso-config'][systemName]
        if (redirectUrl && getFrontConfig().SSO_URL) {
          Vue.ls.remove(ACCESS_TOKEN)
          Vue.ls.remove(ACCESS_SECRET)
          // 认证中心地址
          window.location.href =`${getFrontConfig().SSO_URL}login?redirect=logout`
        }
        else {
          this.Logout().then(res => {
            this.$router.push({
              path: '/login'
            })
            // window.history.pushState(null, '', `${__webpack_public_path__}login`)
            console.log(res)
          }).catch(err => {
            console.log(err)
          })
        }
      } else {
        this.$router.push({
          path: '/MyCenter',
          query: { menuIdx: command }
        })
      }
    },
    goPage(item) {
      item.path ? this.$router.push(item.path) : ''
    }
  }

}
</script>

<style lang="less" scoped>
.globalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #F7F8FA;
}

.head-hall {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}

.head-menu {
  display: flex;
  list-style: none;
  flex: 1;

  li {
    margin-left: 60px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #111111;
    cursor: pointer;
  }
}

.head-action {
  display: flex;
  align-items: center;

  .head-img {
    width: 28px;
    height: 28px;
    border-radius: 50%;

    img {
      width: 100%;
      border-radius: 50%;
    }
  }
  .action {
    font-size: 14px;
    color: #606266;
    margin: 0 12px;
    cursor: pointer;
    &:hover {
      color: #4677ee;
    }
  }
}
.change-system {
    font-size: 14px;
    margin-right: 10px;
    .el-button {
      border: none;
      font-size: 14px;
      color: #000;
      padding: 12px;
      background: transparent;
      &:hover{
        background: transparent;
        color: #4677ee;
      }
    }
  }

  .system-wrapper {
    position: fixed;
    top: 60px;
    left: 20px;
    right: 20px;
    z-index: 1000;
    background: white;
    padding: 50px;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0px 3px 12px 2px rgba(0, 0, 0, 0.45);
    margin: 10px 0 20px 10px;
    animation: move 0.3s ease-in-out;
    .wrap {
      width: 100%;
      display: flex;
      flex: 1;
      justify-content: center;
      list-style-type: none;
      li {
        width: 25%;
        margin-left: 30px;
        .__title {
          font-size: 16px;
          font-weight: 700;
          padding-left: 10px;
          margin-bottom: 15px;
        }
      }
    }
    .menu-list {
      display: flex;
      flex-direction: column;
      flex: 1;
      max-height: 60vh;
      overflow: auto;
      .card {
        border-radius: 10px;
        font-size: 15px;
        display: flex;
        align-items: center;
        img {
          margin-right: 10px;
        }
        &:hover {
          background: #ddd;
          cursor: pointer;
        }
      }
    }
  }
  @keyframes move {
    0% {
      left: -100vw;
    }
    100% {
      left: 20px;
    }
  }

</style>
<style lang="less">
	.change-system-list {
  font-size: 14px;
  line-height: 28px;
  padding: 0 10px;
  cursor: pointer;
  &:hover {
    background-color: #4677ee;
    color: white;
  }
}
</style>